import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPages } from '../redux/slices/PagesAllSlice';
import Header from './Header';

const myPage = "Datenschutz";

function InformationPage() {
  const dispatch = useDispatch();
  const pages = useSelector(state => state.pages.pages);
  const loading = useSelector(state => state.pages.loading);
  const error = useSelector(state => state.pages.error);

  useEffect(() => {
    dispatch(fetchPages());
  }, [dispatch]);

  const selectedPage = pages.find(page => page.name === myPage);

  return (
    <>
      <Header />
      <div className="w-full min-h-screen bg-white px-[17.5rem] py-6">
        {loading && <p>Loading...</p>}
        {error && <p>Error: {error}</p>}
        {selectedPage ? (
          <>
            {/* العناوين في المنتصف */}
            {selectedPage.arrayOfTitles?.length > 0 && (
              <div className="pt-5 text-center">
                {selectedPage.arrayOfTitles.map((title, index) => (
                  <h2 key={index} className="font-bold text-lg">
                    {title}
                  </h2>
                ))}
              </div>
            )}

            {/* النصوص مع الحفاظ على التنسيق */}
            {selectedPage.arrayOfDescriptions?.length > 0 && (
              <div className="pt-5 space-y-4">
                {selectedPage.arrayOfDescriptions.map((description, index) => (
                  <div
                    key={index}
                    className="text-left leading-relaxed"
                    dangerouslySetInnerHTML={{
                      __html: description.replace(/\n/g, "<br />"), // الحفاظ على الأسطر الجديدة
                    }}
                  />
                ))}
              </div>
            )}
          </>
        ) : (
          <p className="text-center text-red-500">Page not found</p>
        )}
      </div>
    </>
  );
}

export default InformationPage;
